import TrustpilotExtended from "./TrustpilotExtended";

export { TrustpilotExtended };
